module.exports = __webpack_public_path__ + "assets/img/relate_line_monitor.c88909a5.png";